import i18n from "i18next";
import {call, put, takeLatest} from "redux-saga/effects";
import {cToast} from "helpers";
import extraService from "./api";
import {extraActions} from "./data";

function* fetchGalleryReport({payload}){
    try{
        const data = yield call(extraService.getGalleryReport,payload);
        yield put(extraActions.fetchGalleryReportSuccess(data));
    }catch (err) {
        yield put(extraActions.fetchGalleryReportFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

export default function* extraSaga(){
    yield takeLatest(extraActions.fetchGalleryReport.type, fetchGalleryReport);
}